
<template>
    <transition name="fade-in" mode="out-in" appear>
        <Content class="max-width" v-if="body">
            <component
                :is="wysiwygComponent"
                v-if="isAdmin"
                :hideToggle="true"
                :theTitle="title"
                :theContent="body"
                @destroyed="editing = false"
            >
                <template v-slot="{ content }">
                    <transition name="fade-in" mode="out-in">
                        <Alert :type="alertType" :hideTitle="true" v-if="showAlert">
                            {{ alertMessage }}
                        </Alert>
                    </transition>

                    <footer class="tab__actions">
                        <Button display="link" style="font-size: 1rem; margin-left: auto;" v-if="isAdmin && !content.editing" @click="content.toggleEdit">Edit {{ title }} <SVGicon-edit /></Button>
                        <Button display="link" style="font-size: 1rem; margin-left: auto;" v-if="isAdmin && content.editing" @click="content.cancelEdit">Cancel</Button>

                        <Button
                            v-if="isAdmin && content.editing"
                            display="primary"
                            :disabled="loading"
                            :class="[
                                'btn--sm',
                                { 'btn--loading' : loading },
                                { 'btn--success' : success }
                            ]"
                            @click="updateContent(content)">
                            {{ btnLabel }} <Spinner v-if="loading" />
                        </Button>
                    </footer>
                </template>
            </component>

            <Content v-if="showStaticContent">
                <h1>{{ title }}</h1>
                <div v-html="body" />
            </Content>
        </Content>
    </transition>
</template>

<script>
import addWysiwygComponent from '@/mixins/addWysiwygComponent.js'
import { mapActions, mapState } from 'vuex'

export default {
    mixins: [addWysiwygComponent],

    data() {
        return {
            loading: false,
            success: null,
            error: null,
            title: null,
            body: null,
        }
    },

    created () {
        // for CMS reasons, we've utilised the "About" content as a page, and assign the page data to the container
        if (this.currentPage && this.currentPage.body) {
            this.title = this.currentPage.name
            this.body = this.currentPage.body

            return
        }

        this.getPageData('/about')
            .then(({ name, body }) => {
                this.title = name
                this.body = body
            })
            .catch(err => console.log(err))
    },

    computed: {
        ...mapState('App', {
            currentPage: state => state.pages.filter(({ path }) => path === '/about')[0]
        }),

        showAlert () {
            return this.error || this.success ? true : false
        },

        alertType () {
            if (this.error) return 'error'
            if (this.success) return 'success'
            return 'default'
        },

        alertMessage () {
            if (this.error) return this.error
            if (this.success) return this.success
            return ''
        },

        btnLabel () {
            if (this.loading) return `Saving ${this.title}...`
            if (this.success) return `Saved ${this.title}`
            return `Save ${this.title}`
        }
    },

    methods: {
        ...mapActions('App', ['getPageData', 'createPage']),

        updateContent (content) {
            this.loading = true
            this.error = null

            const pageData = {
                id: this.currentPage.id,
                name: content.title,
                path: '/about',
                navOrder: 0,
                parentPage: null,
                body: content.body,
                status: 'Published',
                isArticle: false,
                isNew: false,
                hideFromNav: true,
                updateSlug: false
            }

            this.createPage(pageData)
                .then(() => {
                    this.success = `${content.title} updated successfully`
                    this.title = content.title
                    this.body = content.body

                    setTimeout(() => {
                        this.success = null

                        // Toggle the WysiwygEditor components "editing" value to false...
                        content.toggleEdit(false)
                    }, 5000)
                })
                .catch(err => {
                    console.log(err)
                    this.error = err
                })
                .finally(this.loading = false)
        },

    }
}
</script>

